interface FormatOfferFiltersParamsProps {
  courseId?: number;
  hub?: string[];
  location?: string[];
  period?: string[];
}
export const formatOfferFiltersParams = ({
  courseId,
  hub,
  location,
  period,
}: FormatOfferFiltersParamsProps) => {
  const useOfferFiltersRequest: Record<string, string> = {};

  if (courseId) useOfferFiltersRequest.id = courseId.toString();
  if (hub) useOfferFiltersRequest.hub_id = hub.join();
  if (location) {
    const [state, city] = location;

    if (state) useOfferFiltersRequest.state = state;
    if (city) useOfferFiltersRequest.city = city;
  }
  if (period) useOfferFiltersRequest.period = period.join();

  const queryParams = new URLSearchParams(useOfferFiltersRequest).toString();

  return `?${queryParams}`;
};
